<template>
  <div class="compose-message shadowed">
    <div class="header">
      <h3>{{ label }}</h3>
    </div>

    <b-form-row class="gk-input-light--delete">
      <b-col cols="12" lg="0">
        <b-form-group label-class="gk-label-margin gk-modal-label" :label="$gettext('Subject*')" :label-for="subjectId">
          <b-form-input
            :id="subjectId"
            :disabled="disabled"
            :value="subject"
            @update="(value) => $emit('update:subject', value)"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12" lg="0">
        <b-form-group label-class="gk-label-margin gk-modal-label" :label="$gettext('Content*')" :label-for="contentId">
          <b-form-textarea
            :id="contentId"
            :disabled="disabled"
            :value="content"
            @update="(value) => $emit('update:content', value)"
          />
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ComposeMessage',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hasSubject: {
      type: Boolean,
      required: false,
      default: false,
    },
    subject: {
      type: String,
      required: false,
      default: null,
    },
    content: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {},
  computed: {
    subjectId() {
      return `compose-${this.type}-subject`
    },
    contentId() {
      return `compose-${this.type}-content`
    },
  },
})
</script>

<style scoped lang="scss">
.compose-message {
  border: 1px lightgrey solid;
  border-radius: 10px;
  padding: 0.5rem;
  margin-bottom: 1rem;

  .header {
    display: flex;
    flex-direction: column;
  }
}
</style>